import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { GalleryState } from '../../state/gallery.state';
import { Observable } from 'rxjs';
import { GalleryViewMode } from '../../models/gallery-view-mode.enum';
import { GalleryActions } from '../../state/gallery.actions';
import { BookmarkSortModel } from 'src/app/bookmarks/models/bookmark-sort.model';

@Component({
  selector: 'app-gallery-controls',
  templateUrl: './gallery-controls.component.html',
  styleUrls: ['./gallery-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryControlsComponent implements OnInit {
  galleryViewMode = GalleryViewMode;
  
  @Select(GalleryState.getViewMode)
  viewMode$: Observable<GalleryViewMode>;

  @Select(GalleryState.getSort)
  sort$: Observable<BookmarkSortModel>;

  @Select(GalleryState.getSortOptions)
  sortOptions$: Observable<BookmarkSortModel>;

  constructor(
    private store: Store
  ) { }

  ngOnInit() {
  }

  handleSort(sort: BookmarkSortModel) {
    this.store.dispatch(new GalleryActions.SetSort(sort));
  }

  toggleView(viewMode: GalleryViewMode) {
    this.store.dispatch(new GalleryActions.SetViewMode(viewMode));
  }
}
